import { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { formatNearAmount } from 'near-api-js/lib/utils/format';
import { useTranslation } from 'react-i18next';

const QuizCard = ({ acc, quiz, viewOnly, usr }) => {
  let {
    quizId,
    quizTitle,
    quizDescription,
    availableFrom,
    availableTill,
    rewardPerWinner,
    remainingReward,
    percentageToWin,
    allowMultipleTrials,
  } = quiz;

  if (rewardPerWinner == null) rewardPerWinner = 0;

  const [rewarded, setRewarded] = useState(false);

  useEffect(() => {
    usr?.quizSubmissions[quizId]?.submissions.forEach((s) => {
      if (s.hasReceivedReward) {
        setRewarded(true);
      }
    });
  }, []);

  // const [user, setUser] = useState(null);

  // const getUser = async () => {
  //   const usr = await getUserById(acc.accountId);
  //   console.log(usr);
  //   return usr;
  // };

  // useEffect(() => {
  //   try {
  //     getUser()
  //       .then((u) => setUser(u))
  //       .then(() => {
  //         // loop over user.quizSubmissions[quizId].submissions and check if hasReceivedReward is true
  //         // if yes, then setRewarded to true
  //         // else setRewarded to false
  //         user?.quizSubmissions[quizId]?.submissions.forEach((s) => {
  //           if (s.hasReceivedReward) {
  //             setRewarded(true);
  //           }
  //         });
  //       });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }, []);

  const { t, i18n } = useTranslation();

  const trimText = (text, length = 60) => {
    if (text.length > length) {
      return text.substring(0, length) + '...';
    }
    return text;
  };

  return (
    <div
      className={
        i18n.language === 'ar'
          ? 'p-5 mx-auto min-w-full flex flex-col gap-2 sm:flex-row-reverse justify-between items-center bg-white rounded-lg border border-gray-200 shadow-md dark:bg-transparent dark:border-gray-700'
          : 'p-5 mx-auto min-w-full flex flex-col gap-2 sm:flex-row justify-between items-center bg-white rounded-lg border border-gray-200 shadow-md dark:bg-transparent dark:border-gray-700'
      }>
      <div className='flex flex-col gap-2'>
        <h5
          style={{ wordBreak: 'break-word' }}
          className={
            i18n.language === 'ar'
              ? 'mx-auto sm:mr-0 text-2xl font-bold tracking-tight text-gray-900 dark:text-white'
              : 'mx-auto sm:ml-0 text-2xl font-bold tracking-tight text-gray-900 dark:text-white'
          }>
          {quizTitle}
        </h5>
        <p
          className={
            i18n.language === 'ar'
              ? 'font-normal text-lg mx-auto sm:mr-0'
              : 'font-normal text-lg mx-auto sm:ml-0'
          }>
          {trimText(quizDescription)}
        </p>
        <p
          className={
            i18n.language === 'ar'
              ? 'flex flex-row-reverse justify-center items-center sm:justify-start gap-2 w-full'
              : 'flex justify-center items-center sm:justify-start gap-2 w-full'
          }>
          <svg
            className='w-6 h-6 text-primary-500'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'></path>
          </svg>
          <span dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
            {new Date(availableFrom / 1000000).toLocaleDateString(
              i18n.language,
              {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
              }
            )}
          </span>
          {i18n.language === 'ar' ? (
            <svg
              className='w-4 h-4 text-primary-500'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M7 16l-4-4m0 0l4-4m-4 4h18'></path>
            </svg>
          ) : (
            <svg
              className='w-4 h-4 text-primary-500'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M17 8l4 4m0 0l-4 4m4-4H3'></path>
            </svg>
          )}
          <span dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
            {new Date(availableTill / 1000000).toLocaleDateString(
              i18n.language,
              {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
              }
            )}
          </span>
        </p>
        <p
          className={
            i18n.language === 'ar'
              ? 'flex flex-row-reverse justify-center items-center sm:justify-start gap-2 w-full'
              : 'flex justify-center items-center sm:justify-start gap-2 w-full'
          }>
          <svg
            className='w-6 h-6 text-primary-500'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z'></path>
          </svg>
          <span>
            {i18n.language === 'en'
              ? `Score ${percentageToWin}% or higher to win`
              : `أجب على ${percentageToWin}% أو أكثر للفوز`}
          </span>
        </p>
        <p
          className={
            i18n.language === 'ar'
              ? 'flex flex-row-reverse justify-center items-center sm:justify-start gap-2 w-full'
              : 'flex justify-center items-center sm:justify-start gap-2 w-full'
          }>
          <svg
            className='w-6 h-6 text-primary-500'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'></path>
          </svg>
          <span>{formatNearAmount(rewardPerWinner)} NEAR</span>
        </p>
        <p
          className={
            i18n.language === 'ar'
              ? 'flex flex-row-reverse justify-center items-center sm:justify-start gap-2 w-full'
              : 'flex justify-center items-center sm:justify-start gap-2 w-full'
          }>
          <svg
            className='w-6 h-6 text-primary-500'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7'></path>
          </svg>
          {rewardPerWinner === 0 ? (
            <span>
              {i18n.language === 'en' ? 'No-prize quiz' : 'اختبار بدون جائزة'}
            </span>
          ) : (
            <span>
              {i18n.language === 'ar' && 'عدد '}
              {/* Comparing to self -> Checks NaN values */}
              {formatNearAmount(remainingReward) /
                formatNearAmount(rewardPerWinner) !==
              formatNearAmount(remainingReward) /
                formatNearAmount(rewardPerWinner)
                ? 0
                : formatNearAmount(remainingReward) /
                  formatNearAmount(rewardPerWinner)}
              {i18n.language === 'en' ? ' prize(s) left' : ' جائزة متبقي'}
              <span className='text-primary-500'>
                {rewarded
                  ? i18n.language === 'en'
                    ? ' (Rewarded before)'
                    : ' (حصلت على الجائزة من قبل)'
                  : i18n.language === 'en'
                  ? " (Haven't received the reward)"
                  : ' (لم تحصل على الجائزة)'}
              </span>
            </span>
          )}
        </p>
        <p
          className={
            i18n.language === 'ar'
              ? 'flex flex-row-reverse justify-center items-center sm:justify-start gap-2 w-full'
              : 'flex justify-center items-center sm:justify-start gap-2 w-full'
          }>
          <svg
            className='w-6 h-6 text-primary-500'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'></path>
          </svg>
          <span dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
            {usr
              ? usr.quizSubmissions.hasOwnProperty(quizId)
                ? allowMultipleTrials -
                  usr.quizSubmissions[quizId]?.submittedTimes
                : allowMultipleTrials
              : allowMultipleTrials}
            {i18n.language === 'en' ? ' attempt(s) left' : ' محاولات متبقية'}
          </span>
        </p>
        {/* {rewarded && (
          <p
            className={
              i18n.language === 'ar'
                ? 'flex flex-row-reverse justify-center items-center sm:justify-start gap-2 w-full'
                : 'flex justify-center items-center sm:justify-start gap-2 w-full'
            }>
            <svg
              className='w-6 h-6 text-primary-500'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'></path>
            </svg>
            <span dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
              {i18n.language === 'en'
                ? 'Reward received before'
                : 'لقد تلقيت الجائزة من قبل'}
            </span>
          </p>
        )} */}
      </div>

      {viewOnly ? (
        <Link
          to={'/view/' + quizId}
          state={{ isRewarded: rewarded }}
          className={
            i18n.language === 'ar'
              ? 'inline-flex items-center flex-row-reverse py-2 px-4 text-sm font-medium text-center text-white bg-primary-500 rounded-lg hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800'
              : 'inline-flex items-center py-2 px-4 text-sm font-medium text-center text-white bg-primary-500 rounded-lg hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800'
          }>
          {t('quiz-card-view')}
          {i18n.language === 'ar' ? (
            <svg
              className='mr-2 -ml-1 w-4 h-4 min-w-[16px]'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M10 19l-7-7m0 0l7-7m-7 7h18'></path>
            </svg>
          ) : (
            <svg
              className='ml-2 -mr-1 w-4 h-4 min-w-[16px]'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M14 5l7 7m0 0l-7 7m7-7H3'></path>
            </svg>
          )}
        </Link>
      ) : (
        <Link
          to={'/quiz/' + quizId}
          state={{ isRewarded: rewarded }}
          className={
            i18n.language === 'ar'
              ? 'inline-flex items-center flex-row-reverse py-2 px-4 text-sm font-medium text-center text-white bg-primary-500 rounded-lg hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800'
              : 'inline-flex items-center py-2 px-4 text-sm font-medium text-center text-white bg-primary-500 rounded-lg hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800'
          }>
          {t('quiz-card-take')}
          {i18n.language === 'ar' ? (
            <svg
              className='mr-2 -ml-1 w-4 h-4 min-w-[16px]'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M10 19l-7-7m0 0l7-7m-7 7h18'></path>
            </svg>
          ) : (
            <svg
              className='ml-2 -mr-1 w-4 h-4 min-w-[16px]'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M14 5l7 7m0 0l-7 7m7-7H3'></path>
            </svg>
          )}
        </Link>
      )}
    </div>
  );
};
export default QuizCard;
